<template>
  <div>
    <b-modal
      ref="modal-primary"
      id="modal-primary"
      size="xl"
      modal-class="modal-primary"
      centered
      hide-footer
      title="Stok Detayı"
    >
      <div id="invoice-page">
        <div class="items-center justify-between">
          <div class="items-center">
            <b-container fluid class="text-light text-center">
              <b-row>
                <b-col cols="auto" class="p-3">
                  <b-card-text>
                    <span style="color: #ea5455 !important">Stok Adı : </span>
                    {{ stokAdi }}
                  </b-card-text></b-col
                >
                <b-col cols="auto" class="p-3"
                  ><b-card-text>
                    <span style="color: #ea5455 !important">Stok No : </span>
                    {{ stokNo }}
                  </b-card-text>
                </b-col>
              </b-row>
            </b-container>

            <vs-divider color="Default"> </vs-divider>
            <vs-tabs alignment="fixed" style="height: 450px">
              <vs-tab label="Genel Durum">
                <div>
                  <StokEkstreGenel />
                </div>
              </vs-tab>
              <vs-tab label="Hareket Türü">
                <div>
                  <HareketTuru />
                </div>
              </vs-tab>
              <vs-tab label="Alternatifler">
                <div>
                  <StokEkstreAlternatifler />
                </div>
              </vs-tab>
              <vs-tab label="Hareketleri">
                <div>
                  <StokEkstreHareketleri />
                </div>
              </vs-tab>
              <vs-tab label="Resimler">
                <div>
                  <StokEkstreResim />
                </div>
              </vs-tab>
              <vs-tab label="Açık Sat. Sip.">
                <div>
                  <AcikSatisSiparisleri />
                </div>
              </vs-tab>
              <vs-tab label="Açık Alım Sip.">
                <div>
                  <AcikAlimSiparisleri />
                </div>
              </vs-tab>
              <vs-tab label="Alımlar">
                <div>
                  <StokEkstreAlim />
                </div>
              </vs-tab>
              <vs-tab label="Satışlar">
                <div>
                  <StokEkstreSatislar />
                </div>
              </vs-tab>
              <vs-tab label="Sözleşmeler">
                <div>
                  <StokEkstreSozlesmeler />
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import StokEkstreGenel from "./StokEkstreGenel.vue";
import HareketTuru from "./HareketTuru.vue";
import StokEkstreAlternatifler from "./StokEkstreAlternatifler.vue";
import StokEkstreHareketleri from "./StokEkstreHareketleri.vue";
import StokEkstreResim from "./StokEkstreResim.vue";
import AcikAlimSiparisleri from "./AcikAlimSiparisleri.vue";
import StokEkstreAlim from "./StokEkstreAlim.vue";
import StokEkstreSatislar from "./StokEkstreSatislar.vue";
import AcikSatisSiparisleri from "./AcikSatisSiparisleri.vue";
import StokEkstreSozlesmeler from "./StokEkstreSozlesmeler.vue";
import {
  BButton,
  BModal,
  VBModal,
  BFormDatepicker,
  BTabs,
  BTab,
  BCardText,
} from "bootstrap-vue";
export default {
  data() {
    return {
      stokAdi: "",
      stokNo: "",
    };
  },
  components: {
    BTabs,
    BTab,
    StokEkstreGenel,
    HareketTuru,
    StokEkstreAlternatifler,
    StokEkstreHareketleri,
    StokEkstreResim,
    AcikAlimSiparisleri,
    StokEkstreAlim,
    StokEkstreSatislar,
    AcikSatisSiparisleri,
    StokEkstreSozlesmeler,
  },
  methods: {
    stokEkstreDetay() {
      this.$refs["modal-primary"].show();
      this.stokAdi = Store.state.account.stokSTOCKNAME;
      this.stokNo = Store.state.account.stokSTOCKNO;
    },
  },
};
</script>
<style lang="scss">
.con-vs-popup .vs-popup {
  width: 1200px;
}
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir] button:not(:disabled),
[dir] [type="button"]:not(:disabled),
[dir] [type="reset"]:not(:disabled),
[dir] [type="submit"]:not(:disabled) {
  cursor: pointer;
  border: none;
}
</style>